import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { toKebabCase } from '../../../../../utils/helpers/string'
import { useWebhook } from '../../_load/WebhookLoader'
import { useSubdomain } from '../../../../../utils/contexts/UrlProvider'
import LabelValue from '../../../../../packages/kiti/components/presentation/LabelValue'
import Panel from '../../../../../packages/kiti/components/structure/Panel'
import Text, { SmallText } from '../../../../../packages/kiti/components/presentation/Text'

const Details = () => {
  const { t } = useTranslation('webhook')
  const webhook = useWebhook()
  const workspace = useSubdomain()
  const url = `https://api.btime.io/new/webhook/${workspace}/${toKebabCase(webhook.action)}/${webhook.token}`

  const remainingUses = webhook.amountLeft ? t('remainingUses', { count: webhook.amountLeft }) : t('noLimit')

  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <Col width="100%">
        <LabelValue label={t('remainingUse')} value={remainingUses} />
      </Col>

      <Col width="100%">
        <SmallText size="xsmall" color="dark4">
          {t('url')}
        </SmallText>

        <Panel padding={0.5} bgColor="dark2">
          <Text color="white">{url}</Text>
        </Panel>
      </Col>

      <Col width="100%">
        <SmallText size="xsmall" color="dark4">
          {t('conditions')}
        </SmallText>

        <Panel padding={0.5} bgColor="light1">
          <Text>
            <pre>
              <code>{JSON.stringify(webhook.conditions, null, 4)}</code>
            </pre>
          </Text>
        </Panel>
      </Col>

      <Col width="100%">
        <SmallText size="xsmall" color="dark4">
          {t('payload')}
        </SmallText>

        <Panel padding={0.5} bgColor="light1">
          <Text>
            <pre>
              <code>{JSON.stringify(webhook.payload, null, 4)}</code>
            </pre>
          </Text>
        </Panel>
      </Col>
    </Grid>
  )
}

export default Details
